import { render, staticRenderFns } from "./PartnerHealthPrimaryAttorneyYN.vue?vue&type=template&id=8243803c"
import script from "./PartnerHealthPrimaryAttorneyYN.vue?vue&type=script&lang=js"
export * from "./PartnerHealthPrimaryAttorneyYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports